module.exports = __webpack_public_path__ + "img/film-canister.21dee598.svg";